<template>
  <div class="competition-entry-weapper">
    <router-link
      class="back"
      :to="{ name: 'Competition', params: $route.params }"
    >
      <img
        src="@/assets/icons/backArrow2.png"
        style="margin-right: 10px;"
        alt=""
      />
      {{ $t("competitions.tr.backToCompetition") }}
    </router-link>
    <p v-html="$t('competitions.tr.termsConditionsTxt')"></p>
    <div class="modal-checkbox">
      <label class="checkbox-wrapper">
        <input
          autocomplete="off"
          @change="rulesError = false"
          v-model="rules"
          type="checkbox"
        />
        <span class="checkmark"></span>
      </label>
      <!-- <router-link
        target="_blank"
        :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
      >
        <div class="modal-checkbox-text">
          {{ $t('competitions.tr.acceptTerms') }}
        </div>
      </router-link> -->
      <router-link
        target="_blank"
        :to="{ name: 'CompetitionRules', params: $route.params }"
      >
        <div class="modal-checkbox-text">
          {{ $t("competitions.tr.acceptTerms") }}
        </div>
      </router-link>
    </div>

    <div v-for="input in work" :key="input.key" class="input-wrapper">
      <!-- @input="input.showLengthError = false" -->
      <div v-if="input.key === 'school'" class="input-wrapper">
        <dropdown
          :defaultText="$t('competitions.tr.institutionName')"
          :customSeach="true"
          :selected="school"
          :list="schoolList"
          :schools="true"
          @changeOption="(school = $event), setupSchoolData()"
          :removable="true"
          @remove="(school = null), setupSchoolData()"
          @search="(search = $event), getSchools()"
        />
      </div>
      <input
        v-else-if="input.key === 'wrk_phone_number'"
        onkeydown="this.value = this.value.replace(/(?!^\+)[^0-9 ]/g, '').replace(/[ ]{2,}/g, '');"
        oninput="this.value = this.value.replace(/(?!^\+)[^0-9 ]/g, '').replace(/[ ]{2,}/g, '');"
        v-model="input.value"
        type="text"
        :placeholder="$t(input.label)"
        class="regular-input"
        :maxlength="input.length"
        :disabled="input.disabled"
      />
      <input
        v-else
        v-model="input.value"
        type="text"
        :placeholder="$t(input.label)"
        class="regular-input"
        :maxlength="input.length"
      />
      <div class="label-wrapper">
        <span
          v-if="
            input.value !== null &&
              input.value !== '' &&
              input.key === 'wrk_phone_number'
          "
          class="label"
          >{{ $t("main.phoneInfo") }}</span
        >
        <span
          v-if="
            input.value !== null &&
              input.value !== '' &&
              input.key !== 'wrk_phone_number'
          "
          class="label"
          >{{ $t(input.label) }}</span
        >
        <!-- <span v-if="input.showLengthError" class="error">{{
          input.lengthErrorText
        }}</span> -->
      </div>
    </div>

    <div v-if="type === 1" class="image-wrapper">
      <label for="work-image">
        <div class="work-image-btn">
          {{ $t("competitions.tr.selectFile") }}
        </div>
        <div class="image-name">
          {{ image && image.name ? image.name : $t("competitions.tr.noFile") }}
        </div>
      </label>
      <input
        type="file"
        id="work-image"
        accept="application/pdf"
        @change="image = $event.target.files[0]"
      />
    </div>

    <div v-if="type === 2" class="input-wrapper">
      <input
        v-model="link"
        type="text"
        :placeholder="$t('competitions.tr.link')"
        class="regular-input"
        :maxlength="255"
      />
      <div class="label-wrapper">
        <span v-if="link !== null && link !== ''" class="label">
          {{ $t("competitions.tr.link") }}
        </span>
      </div>
    </div>

    <div v-if="type === 3" class="image-wrapper">
      <label for="work-image">
        <div class="work-image-btn">
          {{ $t("competitions.tr.selectFile") }}
        </div>
        <div class="image-name">
          {{ image && image.name ? image.name : $t("competitions.tr.noFile") }}
        </div>
      </label>
      <input
        type="file"
        id="work-image"
        accept="image/jpeg, image/png"
        @change="image = $event.target.files[0]"
      />
    </div>

    <div class="input-wrapper">
      <!-- @input="input.showLengthError = false" -->
      <input
        v-model="password"
        type="password"
        :placeholder="$t('competitions.tr.passwordWork')"
        class="regular-input"
        :maxlength="255"
      />
      <div class="label-wrapper">
        <span v-if="password !== null && password !== ''" class="label">{{
          $t("competitions.tr.passwordWork")
        }}</span>
      </div>
    </div>
    <TurnStile @set-token="setToken" />
    <div class="btn-wrapper">
      <div :class="{ inv: !hasAllData }" @click="postWork()" class="btn">
        {{ $t("competitions.tr.saveChanges") }}
      </div>
      <div @click="openDeleteModal" class="btn dark">
        {{ $t("competitions.tr.deleteWork") }}
      </div>
      <div @click="navigateBack" class="btn transparent">
        {{ $t("competitions.tr.dropChanges") }}
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from "@/components/dropdown.vue";
import { workOptions } from "@/js/competitionInputs.js";
import eventBus from "@/shared/eventBus.js";
import { api } from "@/api";
import TurnStile from "../components/TurnStileVue2.vue";
export default {
  name: "CompetitionEntry",
  components: {
    Dropdown,
    TurnStile
  },
  data() {
    return {
      rules: true,
      rulesError: false,
      // wrk_sponosor string 255 nemoj da saljes za sad
      // sch_id id od skole, nemoj da saljes za sad
      image: null,
      link: "",
      age: null,
      type: null,
      work: [],
      password: null,
      schoolList: [],
      school: null,
      search: "",
      localToken: ""
    };
  },
  activated() {
    this.setupData();
  },
  deactivated() {
    this.$store.commit("setCompetitionWork", null);
  },
  mounted() {
    this.getCompetition().then(() => {
      this.getSchools();
    });
  },
  methods: {
    setToken(e) {
      this.localToken = e;
    },
    navigateBack() {
      this.$router.back();
    },
    openDeleteModal() {
      let modalData = {
        title: this.$t("competitions.tr.enterCodePass") + ":",
        ok: (data, credentials) => {
          this.deleteWork(credentials);
        }
      };
      let params = {
        modalData: modalData,
        component: "editWorkSetup"
      };
      eventBus.$emit("openModal", params);
    },
    async deleteWork(data) {
      try {
        let res = await api.deleteWorkData(data);
        this.$toast.success(this.$t("competitions.tr.sucessDelete"), {
          duration: 8000
        });
        this.$router.push({
          name: "CompetitionRankList",
          params: this.$route.params
        });
      } catch (e) {
        this.$toast.error(this.$t("competitions.tr.errDelete"), {
          duration: 8000
        });
      }
    },
    setupSchoolData() {
      if (!this.school) {
        for (var i = 0; i < this.work.length; i++) {
          if (this.work[i].key === "sch_region") {
            this.work[i].value = "";
          }
          if (this.work[i].key === "sch_address") {
            this.work[i].value = "";
          }
        }
      } else {
        for (var i = 0; i < this.work.length; i++) {
          if (this.work[i].key === "sch_region") {
            this.work[i].value = this.school.sch_region;
          }
          if (this.work[i].key === "sch_address") {
            this.work[i].value = this.school.sch_address;
          }
        }
      }
    },
    async getSchools() {
      if (this.search !== "" && this.age !== null) {
        let params = {
          search: this.search,
          age: this.age
        };
        try {
          let res = await api.getSchools(params);
          this.schoolList = [];
          for (var i = 0; i < res.data.data.length; i++) {
            let school = res.data.data[i];
            school.label = school.sch_name + " (" + school.sch_region + ")";
            school.value = school.sch_id;
            this.schoolList.push(school);
          }
        } catch (e) {
          console.log(e);
        } finally {
        }
      }
    },
    setupData() {
      let data = this.$store.state.competitionWork;
      if (!data) {
        this.$router.push({
          name: "CompetitionRankList",
          params: this.$route.params
        });
      } else {
        for (var i = 0; i < this.work.length; i++) {
          if (this.work[i].key === "school") {
            this.work[i].value = "school";
          } else {
            this.work[i].value = data[this.work[i].key];
          }
        }
        this.link = data.wrk_work;
        let obj = {
          sch_address: data.sch_address,
          sch_id: data.sch_id,
          sch_name: data.sch_name,
          sch_region: data.sch_region,
          label: data.sch_name + " (" + data.sch_region + ")",
          value: data.sch_id
        };
        this.school = obj;
      }
    },
    async getCompetition() {
      try {
        let params = {
          id: this.$route.params.id
        };
        let res = await api.getCompetition(params);
        this.type = res.data.data.cmp_type;
        this.age = res.data.data.cmp_age;
        this.work = JSON.parse(JSON.stringify(workOptions[this.age]));
        this.setupData();
      } catch (e) {
        console.log(e);
      }
    },
    clearInputs() {
      for (var i = 0; i < this.work.length; i++) {
        this.work[i].value = "";
      }
      this.rules = false;
      this.image = null;
      this.link = "";
      let imagehtml = document.getElementById("work-image");
      if (imagehtml && imagehtml.value) {
        imagehtml.value === null;
      }
    },
    async postWork() {
      for (var i = 0; i < this.work.length; i++) {
        if (this.work[i].key === "wrk_name") {
          if (this.work[i].value.length < 5) {
            this.$toast.error(this.$t("competitions.tr.err5Char"), {
              duration: 8000
            });
            return;
          }
        }
      }
      if (!this.rules) {
        this.$toast.error(this.$t("competitions.tr.errAcceptTerms"), {
          duration: 8000
        });
        return;
      }
      if (this.age !== 4 && !this.school) {
        this.$toast.error(this.$t("competitions.tr.errInstitution"), {
          duration: 8000
        });
        return;
      }
      if (!this.hasAllData) {
        this.$toast.error(this.$t("competitions.tr.errAllFields"), {
          duration: 8000
        });
        return;
      }
      let fd = new FormData();
      for (var i = 0; i < this.work.length; i++) {
        if (
          this.work[i].value !==
          this.$store.state.competitionWork[this.work[i].key]
        ) {
          fd.append(this.work[i].key, this.work[i].value);
        }
      }
      if (this.$store.state.competitionWork.wrk_code) {
        fd.append("wrk_code", this.$store.state.competitionWork.wrk_code);
      }
      fd.append("wrk_password", this.password);
      if (this.age !== 4) {
        fd.append("sch_id", this.school.sch_id);
      }
      if (this.link) {
        fd.append("wrk_text", this.link);
      }
      if (this.image) {
        fd.append("file", this.image);
      }
      // let token = await this.$recaptcha("editWork");
      fd.append("token", this.localToken);

      eventBus.$emit("showLoader", true);
      api
        .editWorkData(fd, this.$route.params.id)
        .then(res => {
          this.$toast.success(this.$t("competitions.tr.successChangeWork"), {
            duration: 8000
          });
          this.$store.commit("setCompetitionWork", null);
          this.clearInputs();
          this.$router.push({
            name: "CompetitionRankList",
            params: this.$route.params
          });
        })
        .catch(e => {
          if (e.response.data.message === "nothing-changed") {
            this.$toast.error(this.$t("competitions.tr.nothingChanged"), {
              duration: 8000
            });
          } else if (e.response.data.message === "competition-not-active") {
            this.$toast.error(this.$t("competitions.tr.notActive"), {
              duration: 8000
            });
          } else if (e.response.data.message === "invalid-wrk_email") {
            this.$toast.error(this.$t("competitions.tr.errMail"), {
              duration: 8000
            });
          } else {
            this.$toast.error(this.$t("competitions.tr.error"), {
              duration: 8000
            });
          }

          console.log(e.response.data.message);
        })
        .finally(() => {
          eventBus.$emit("showLoader", false);
        });
    }
  },
  computed: {
    hasAllData() {
      if (this.age !== 4 && this.school === null) {
        return false;
      }
      if (!this.password || this.password === "") {
        return false;
      }
      if (this.type === 2 && this.link === "") {
        return false;
      }
      if ((this.type === 1 || this.type === 3) && this.image === null) {
        return false;
      }
      return !this.work.find(el => {
        if (
          el.key === "sch_address" ||
          el.key === "sch_region" ||
          el.key === "wrk_sponsor_name" ||
          el.key === "wrk_sponsor_link"
        ) {
          return false;
        } else {
          return !el.value || el.value === "";
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/inputStyles.scss";
@import "@/assets/scss/checkboxStyles.scss";

.inv {
  // pointer-events: none;
}
.competition-entry-weapper {
  margin: 0 auto;
  max-width: 1320px;
  width: calc(100% - 40px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 70px;
  padding-bottom: 70px;

  .btn-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .btn {
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }

  .back {
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;
    color: rgba(140, 140, 140, 0.96);
    cursor: pointer;
    text-decoration: none;
    margin-bottom: 50px;
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  p {
    font-weight: 400;
    font-size: 20px;
    line-height: 194.9%;
    margin-bottom: 20px;
    text-align: left;
    color: rgba(100, 100, 100, 0.96);

    span {
      font-weight: 600;
    }
  }

  .modal-checkbox {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    margin-bottom: 30px;

    a {
      text-decoration: none;
    }

    .modal-checkbox-text {
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.04em;
      color: $main-text-color;
    }
  }

  .input-wrapper {
    max-width: 100%;
    margin-bottom: 20px;
    min-height: 46px;
    width: 400px;

    .info {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;

      .info-key {
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 21px;
        letter-spacing: 0.04em;
        color: #606060;
        margin-right: 15px;
        white-space: break-spaces;
        width: 200px;
        text-align: left;
        margin-bottom: 10px;
      }
      .info-value {
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 21px;
        letter-spacing: 0.04em;
        color: #606060;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        flex-grow: 1;

        span {
          margin-right: 10px;
        }
      }
    }

    .regular-input {
      width: 100%;
      color: #606060;
    }
    .regular-input::placeholder {
      color: #606060;
      opacity: 1;
    }
    .label-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      span {
        font-weight: 800;
        font-size: 12px;
        line-height: 15px;
        letter-spacing: 0.06em;
        color: rgba(160, 160, 160, 0.9);
        opacity: 0.5;
      }
      .error {
        opacity: 1;
        color: #ef3725;
        margin-left: auto;
        text-decoration: underline;
        font-size: 14px;
        margin-top: 2px;
      }
    }
  }

  .image-wrapper {
    label {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 50px;
      flex-wrap: wrap;

      .image-name {
        line-height: 33px;
      }
      .work-image-btn {
        border: 1px solid #c2c2c2;
        box-sizing: border-box;
        border-radius: 6px;
        height: 33px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-right: 20px;
        white-space: nowrap;
      }
    }
    #work-image {
      display: none;
    }
  }
}
</style>
